import { _firestore } from '../../firebase';
import ActionTypes from './constants';
import storeConfig from '../../configuration/storeConfig';
import {
  getJsonDataFromFile,
  getUpdatedStoreMenuUrls,
} from './store-json-data-methods';
import getImage from '../../components/NewMenuItem/getImage';

export function getSuburbs() {
  return async (dispatch) => {
    try {
      const promises = [];
      for (const s of storeConfig.stores) {
        const { suburbsStorageUrl } = await getUpdatedStoreMenuUrls(s.storeId);
        if (suburbsStorageUrl) {
          promises.push(getJsonDataFromFile('suburbs', suburbsStorageUrl));
        }
      }

      const values = await Promise.all(promises);
      let arrays = values.reduce((a, b) => a.concat(b), []);
      dispatch(suburbsFetched(arrays));
    } catch (error) {
      console.error('Error fetching suburbs:', error);
      dispatch(suburbsFetched([]));
    }
  };
}

function getSettingsPromise(storeId) {
  return new Promise((resolve, _reject) => {
    _firestore
      .collection('OrderSetup')
      .where('storeId', '==', storeId)
      .get()
      .then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        resolve(dataArray);
      })
      .catch(() => {
        resolve([]);
      });
  });
}

export function getSettings() {
  return (dispatch) => {
    let requests = storeConfig.stores.map((s) => {
      return getSettingsPromise(s.storeId);
    });
    Promise.all(requests)
      .then((values) => {
        let arrays = values.reduce((a, b) => a.concat(b), []);
        dispatch(settingsFetched(arrays));
      })
      .catch((error) => {
        dispatch(settingsFetched([]));
      });
  };
}

function getStoresPromise(storeId) {
  return new Promise((resolve, _reject) => {
    _firestore
      .collection('Stores')
      .doc(storeId)
      .get()
      .then((doc) => {
        resolve(getStoreInfo({ _id: doc.id, ...doc.data() }));
      })
      .catch(() => {
        resolve([]);
      });
  });
}

export function getStores() {
  return (dispatch) => {
    let requests = storeConfig.stores.map((s) => {
      return getStoresPromise(s.storeId);
    });
    Promise.all(requests)
      .then((values) => {
        dispatch(storesFetched(values));
      })
      .catch((error) => {
        dispatch(storesFetched([]));
      });
  };
}

export function getPopulars(storeId) {
  return async (dispatch) => {
    const { popularsStorageUrl } = await getUpdatedStoreMenuUrls(storeId);
    const populars = await getJsonDataFromFile('populars', popularsStorageUrl);
    const popularsArray = populars?.map((p) => {
      return {
        _id: p.menuItemId,
        categoryId: p.categoryId,
        name: p.name,
        urlS3: p.urlS3,
        url: p.url,
        date: p.date,
        dateTimestamp: p.dateTimestamp,
        isAvailable: p.isAvailable,
        isGlutenFree: p.isGlutenFree,
        mediaPath: p.mediaPath,
        storeId: p.storeId,
        restaurantId: p.restaurantId,
        selectedExtraIngredients: p.selectedExtraIngredients,
        selectedIngredients: p.selectedIngredients,
        selectedSizes: p.selectedSizes,
        description: p.description,
      };
    });
    dispatch(popularFetched(popularsArray));
  };
}

function getStoreInfo(storeObj) {
  let {
    _id,
    name,
    city,
    addressLocation,
    area,
    areaCode,
    country,
    countryIdentifier,
    emailAddress,
    logo,
    logoPath,
    phoneNumber,
    state,
    street,
    timeZone,
    currency,
    connectId,
    isProductionEnv,
    baseUrl,
    baseUrls,
    storePhotoPath,
    storePhotoURL,
  } = storeObj;
  const storePhoto = getImage(
    storePhotoPath || storePhotoURL || logoPath || logo
  );

  let store = {
    _id,
    name,
    addressLocation,
    area,
    areaCode,
    city,
    country,
    countryIdentifier,
    emailAddress,
    logo: getImage(logoPath || logo),
    phoneNumber,
    state,
    street,
    timeZone,
    currency,
    connectId,
    isProductionEnv,
    baseUrl: baseUrl || baseUrls?.[0],
    storePhotoURL: storePhoto,
  };
  return store;
}

function popularFetched(populars) {
  return {
    type: ActionTypes.PopularsFetched,
    populars,
  };
}

function storesFetched(stores) {
  return {
    type: ActionTypes.FetchStores,
    stores,
  };
}

function settingsFetched(settings) {
  return {
    type: ActionTypes.FetchOrderSetups,
    settings,
  };
}

function suburbsFetched(suburbs) {
  return {
    type: ActionTypes.FetchSuburbs,
    suburbs,
  };
}
